import React, { useEffect, useRef } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import 'ckeditor5/ckeditor5.css';

const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
};

const MyEditor = ({ htmlData, setCourseAdd }) => {
    const editorContainerRef = useRef(null);

    useEffect(() => {
        const element = editorContainerRef.current;

        if (element) {
            const handleResize = debounce(() => {
            }, 100);

            const resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(element);

            return () => {
                resizeObserver.unobserve(element);
            };
        }
    }, []);

    return (
        <div className="ctm-editor" ref={editorContainerRef}>
            <CKEditor
                editor={ClassicEditor}
                config={{
                    licenseKey: "GPL",
                    placeholder: "Write here...",
                    toolbar: {
                        items: [
                            "undo",
                            "redo",
                            "|",
                            "heading",
                            "|",
                            "bold",
                            "italic",
                            "|",
                            "link",
                            // "uploadImage",
                            // "insertTable",
                            "blockQuote",
                            // "mediaEmbed",
                            "|",
                            "bulletedList",
                            "numberedList",
                            // "outdent",
                            // "indent",
                        ],
                        shouldNotGroupWhenFull: true,
                    },
                    image: {
                        toolbar: [
                            "imageStyle:inline",
                            "imageStyle:block",
                            "imageStyle:side",
                            "|",
                            "toggleImageCaption",
                            "imageTextAlternative",
                        ],
                    },
                    table: {
                        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
                    },
                    heading: {
                        options: [
                            { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
                            { model: "heading1", view: "h1", title: "Heading 1", class: "ck-heading_heading1" },
                            { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
                            { model: "heading3", view: "h3", title: "Heading 3", class: "ck-heading_heading3" },
                            { model: "heading4", view: "h4", title: "Heading 4", class: "ck-heading_heading4" },
                            { model: "heading5", view: "h5", title: "Heading 5", class: "ck-heading_heading5" },
                            { model: "heading6", view: "h6", title: "Heading 6", class: "ck-heading_heading6" },
                        ],
                    },
                }}
                data={htmlData || ""}
                onChange={(event, editor) => {
                    const data = editor.getData();
                    if (data !== htmlData) {
                        if (typeof setCourseAdd === "function") {
                            setCourseAdd(data);
                        } else {
                            console.error("setCourseAdd is not a function!");
                        }
                    }
                }}
            />
        </div>
    );
};

export default MyEditor;
